export type IFCParseOption = 'wall' | 'wallOpening' | 'roof'

export const IFCParseOptions: { label: string; value: IFCParseOption }[] = [
  {
    label: 'Wand',
    value: 'wall' as IFCParseOption,
  },
  {
    label: 'Wandöffnung',
    value: 'wallOpening' as IFCParseOption,
  },
  {
    label: 'Dachfläche',
    value: 'roof' as IFCParseOption,
  },
]
